/**
 * The chat region of the frame (v1's `EmptyPanel` and the shell's `.chat`).
 * As a panel — Empty, and the free column of State 1 — it is the launcher, or
 * the conversation once there is one. Under a widget it is the slim history.
 * The box is always there. A write the agent asks for is a line of the
 * conversation (`Request.tsx`), not a card above the box.
 */
import { Launcher } from "../shell/Launcher";
import { ChatHistory } from "./ChatHistory";
import { ChatStrip } from "./ChatStrip";
import styles from "./ChatRegion.module.css";
import { useChat } from "./store";

export function ChatRegion({ panel }: { panel: boolean }) {
  const talking = useChat((s) => s.lines.length > 0 || s.running);
  return (
    <>
      {panel &&
        (talking ? (
          <ChatHistory />
        ) : (
          <div className={styles.launcher}>
            <Launcher />
          </div>
        ))}
      {!panel && <ChatHistory compact />}
      <ChatStrip />
    </>
  );
}
